/** 暗潮管理后台 Mock 数据（后续对接 AcApi） */

export const dashboardStats = {
  userCount: 1286,
  orderToday: 18,
  revenueToday: 4280,
  rechargeToday: 5680,
  rechargeTodayCount: 12,
  withdrawToday: 1260,
  withdrawTotal: 38500
}

export const mockUsers = [
  { id: 10001, nickname: '暗潮用户8821', phone: '13800138821', balance: 1280, vipLevel: 1, status: 'active', registerTime: '2026-06-01 10:20:00', lastLogin: '2026-06-16 09:12:33' },
  { id: 10002, nickname: '暗潮用户6654', phone: '13900136654', balance: 560, vipLevel: 0, status: 'active', registerTime: '2026-06-05 14:08:22', lastLogin: '2026-06-15 20:45:11' },
  { id: 10003, nickname: '暗潮用户9900', phone: '13700139900', balance: 0, vipLevel: 0, status: 'active', registerTime: '2026-06-10 08:30:15', lastLogin: '2026-06-14 11:22:08' },
  { id: 10004, nickname: '暗潮用户1122', phone: '13600131122', balance: 2000, vipLevel: 2, status: 'active', registerTime: '2026-05-20 16:45:00', lastLogin: '2026-06-16 07:55:42' },
  { id: 10005, nickname: '暗潮用户7788', phone: '13500137788', balance: 88, vipLevel: 0, status: 'disabled', registerTime: '2026-06-12 19:12:44', lastLogin: '2026-06-13 22:10:05' }
]

export const mockPlans = [
  {
    id: 1,
    name: '分组缩水 · 10组大底',
    subtitle: '稳健型 · 高命中率',
    tag: '推荐',
    tagColor: '#00d4ff',
    price: 0.5,
    totalDadi: 10,
    notesPerDadi: 800,
    soldRate: 72,
    status: 'online',
    lotteryName: 'TW5FC',
    description: '基于TW5FC后三位分析，10组3D大底每组800+注'
  },
  {
    id: 2,
    name: '计划B · 已下架',
    subtitle: '激进型 · 高回报',
    tag: '热门',
    tagColor: '#7c3aed',
    price: 0.5,
    totalDadi: 10,
    notesPerDadi: 800,
    soldRate: 85,
    status: 'online',
    lotteryName: 'TW5FC',
    description: 'TW5FC后三位冲击方案，10组3D大底每组800+注'
  }
]

/** 方案算法配置 */
export const mockGlobalAlgorithm = {
  digitCount: 3,
  digitLabels: '百 · 十 · 个',
  notesPerDadi: 800,
  notesPerDadiMax: 860,
  planCoreSize: 700,
  planCoreSizeMax: 900,
  totalDadiPerPlan: 10,
  numberPoolSize: 1000,
  intersectToleranceMin: 0,
  intersectToleranceMax: 2,
  generateMode: 'dingwei_fushi',
  description: '定位复式：3-3-3·5000公式去重·分组容错·自动搜10次·容错交集0~0·840-865注×10组',
        dingweiAlgo: {
          pos1: '百', pos2: '十', pos3: '个',
          count1: 3, count2: 3, count3: 3,
          extractMatch: '23', searchPeriods: 3,
          hitRateMin: 100, hitRateMax: 100,
          formulaCount: 5000, formulaUnique: true,
          groupSize: 5, condMatch: '012',
          groupTolMin: 0, groupTolMax: 2,
          finalTolMin: 0, finalTolMax: 1,
          missMatch: '012', missStreakMin: 1, missStreakMax: 2,
          shrinkMode: 'group', unionPrevEq23: false,
          backtestPeriods: 100, backtestSearchMode: 'multi',
          multiSearchCount: 10, intersectMode: 'tolerance',
          intersectTolMin: 0, intersectTolMax: 0,
          intersectMissMin: 1, intersectMissMax: 1
        }
}

export const mockPlanAlgorithms = [
  {
    id: 1,
    planId: 1,
    planName: '计划A · 稳胆系列',
    seedBase: 13579,
    coreSize: 360,
    notesPerDadi: 800,
    extraSeedFactor: 313,
    intersectMin: 0,
    intersectMax: 2,
    status: 'enabled',
    updateTime: '2026-06-20 10:30:00'
  },
  {
    id: 2,
    planId: 2,
    planName: '计划B · 冲击系列',
    seedBase: 24680,
    coreSize: 360,
    notesPerDadi: 800,
    extraSeedFactor: 9973,
    intersectMin: 0,
    intersectMax: 2,
    status: 'enabled',
    updateTime: '2026-06-20 10:30:00'
  }
]

export const mockOrders = [
  { id: 'ORD20260616001', userId: 10001, userPhone: '13800138821', lotteryName: 'TW5FC', planName: '计划A · 稳胆系列', dadiName: '方案0容错交集大底', numbers: '共860注', amount: 0.5, status: 'paid', createTime: '2026-06-16 14:32:18' },
  { id: 'ORD20260615002', userId: 10002, userPhone: '13900136654', lotteryName: 'TW5FC', planName: '计划B · 冲击系列', dadiName: '方案0容错交集大底', numbers: '共860注', amount: 368, status: 'completed', createTime: '2026-06-15 09:15:42' },
  { id: 'ORD20260615003', userId: 10004, userPhone: '13600131122', lotteryName: 'TW5FC', planName: '计划A · 稳胆系列', dadiName: '方案0容错交集大底', numbers: '共860注', amount: 0.5, status: 'pending', createTime: '2026-06-15 20:08:33' },
  { id: 'ORD20260614004', userId: 10003, userPhone: '13700139900', lotteryName: 'TW5FC', planName: '计划B · 冲击系列', dadiName: '方案0容错交集大底', numbers: '共860注', amount: 368, status: 'cancelled', createTime: '2026-06-14 11:22:08' },
  { id: 'ORD20260613005', userId: 10001, userPhone: '13800138821', lotteryName: 'TW5FC', planName: '计划B · 冲击系列', dadiName: '方案0容错交集大底', numbers: '共860注', amount: 368, status: 'completed', createTime: '2026-06-13 16:45:00' }
]

export const mockRechargeRecords = [
  { id: 'RCH20260616001', userId: 10001, userPhone: '13800138821', amount: 500, bonus: 50, payMethod: '微信', status: 'success', createTime: '2026-06-16 10:20:00' },
  { id: 'RCH20260615002', userId: 10002, userPhone: '13900136654', amount: 200, bonus: 15, payMethod: '支付宝', status: 'success', createTime: '2026-06-15 18:30:22' },
  { id: 'RCH20260614003', userId: 10004, userPhone: '13600131122', amount: 1000, bonus: 120, payMethod: '微信', status: 'success', createTime: '2026-06-14 09:12:44' },
  { id: 'RCH20260613004', userId: 10003, userPhone: '13700139900', amount: 100, bonus: 5, payMethod: '支付宝', status: 'pending', createTime: '2026-06-13 14:08:11' }
]

export const rechargeOptions = [
  { id: 1, amount: 50, bonus: 0 },
  { id: 2, amount: 100, bonus: 5 },
  { id: 3, amount: 200, bonus: 15 },
  { id: 4, amount: 500, bonus: 50 }
]

export const mockBanners = [
  { id: 1, title: 'TW5FC预售', subtitle: '每5分钟开奖 · 两套计划各10组3D大底', tag: '限时预售', gradient: 'linear-gradient(135deg, #0ea5e9 0%, #7c3aed 100%)', sort: 1, status: 'online' },
  { id: 2, title: '计划A · 稳胆系列', subtitle: '10组3D大底 · 每组800+注', tag: '推荐', gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', sort: 2, status: 'online' },
  { id: 3, title: '计划B · 冲击系列', subtitle: '10组3D大底 · 每组800+注', tag: '热门', gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)', sort: 3, status: 'online' },
  { id: 4, title: '充值享赠礼', subtitle: '最高赠送 ¥300 充值红包', tag: '活动', gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', sort: 4, status: 'offline' }
]

export const recentOrders = mockOrders.slice(0, 5)

function delay(ms = 300) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export async function mockRequest(data, ms) {
  await delay(ms)
  return { code: 0, data, message: 'ok' }
}

export async function mockLogin(username, password) {
  await delay(500)
  if (username === 'admin' && password === 'admin123') {
    return {
      code: 0,
      data: {
        token: 'admin_token_' + Date.now(),
        admin: { id: 1, username: 'admin', nickname: '超级管理员', role: 'super' }
      }
    }
  }
  return { code: 401, message: '账号或密码错误' }
}
